// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1tz68","tab":"styles_tab__3Na7u","selected":"styles_selected__-facp","icon":"styles_icon__30Otj"};